export enum LoginResult {
  Success = 'success',
  IncorrectDetails = 'incorrect_details',
  NoAccess = 'no_access',
  NoToken = 'no_token',
}
